import _ from 'lodash';
import moment from 'moment';
import * as actionTypes from 'constants/ActionTypes';
import mockOrder from 'mocks/vessel/order.json';

const vesselOrders = (state = {
    items: [],
    user: {
        email: '',
        company: '',
        name: '',
        surname: '',
        phones: [{
            code: '',
            phone: '',
        }],
    },
}, action) => {
    switch (action.type) {
    case actionTypes.REMOVE_ALL_VESSEL_ORDERS: {
        return {
            ...state,
            items: [],
        };
    }
    case actionTypes.UPDATE_VESSEL_ORDER_USER: {
        const newState = _.cloneDeep(state);
        newState.user = { ...action.user };
        return newState;
    }
    case actionTypes.CREATE_VESSEL_ORDERS: {
        return {
            ...state,
            items: action.items,
            user: Object.assign({}, state.user, action.user),
        };
    }
    case actionTypes.GET_VESSEL_ORDERS:
        return state;
    case actionTypes.UPDATE_VESSEL_ORDER: {
        const newState = _.cloneDeep(state);
        newState.items[action.numberOrder] = action.newVesselOrder;
        return newState;
    }
    case actionTypes.REMOVE_LAST_VESSEL_ORDER: {
        const newState = _.cloneDeep(state);
        newState.items.splice(-1, 1);
        return newState;
    }
    case actionTypes.RESET_VESSEL_ORDERS: {
        const newState = _.cloneDeep(state);
        newState.items = [mockOrder];
        return newState;
    }
    case actionTypes.ADD_VESSEL_ORDER: {
        const newState = _.cloneDeep(state);
        const cloneMockOrder = _.cloneDeep(mockOrder);

        cloneMockOrder.open[0].until = moment().format('MM-DD-YYYY');
        cloneMockOrder.open[0].from = moment().format('MM-DD-YYYY');

        newState.items.push({ ...cloneMockOrder });
        return newState;
    }

    case actionTypes.POST_VESSEL_REQUEST.REQUEST: {
        const newState = _.cloneDeep(state);
        newState.items.forEach((item) => {
            item.validateErrors = [];
        });
        return newState;
    }
    case actionTypes.POST_VESSEL_REQUEST.FAILURE: {
        const newState = _.cloneDeep(state);
        const cargoRequest = newState.items[action.vesselRequest.keyVesselOrder];
        cargoRequest.validateErrors = action.errors;
        return newState;
    }
    case actionTypes.POST_VESSEL_REQUEST.SUCCESS: {
        const newState = _.cloneDeep(state);
        return newState;
    }
    case actionTypes.CLEAR_VESSEL_ORDER_MESSAGE: {
        const newState = _.cloneDeep(state);
        return newState;
    }

    default:
        return state;
    }
};

export default vesselOrders;



// WEBPACK FOOTER //
// ./app/reducers/vessels/orders.js